exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cell-status{display:flex;flex-direction:row;align-items:center;width:100%}.cell-status .project-graph{margin-left:12px;margin-top:2px;position:relative}.cell-status .project-graph .status{position:absolute;top:47%;left:50%;transform:translate(-50%,-50%)}.cell-status .project-graph .status .status-percent,.cell-status .status-container{color:#4a4a4a;font-size:14px;font-family:Open Sans,sans-serif}.cell-status .status-container{overflow:hidden;width:70%}.cell-status .status-container .completed-at{margin-left:12px;margin-top:2px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/graphics/ProjectStatusGraphic/ProjectStatusGraphic.scss
// module id = 1697
// module chunks = 0